import { Css } from "@homebound/beam";
import { ObjectConfig } from "@homebound/form-state";
import { ChangeEventWorkflow } from "src/generated/graphqlTypes";
import { GuidedChangeEventStep } from "src/routes/projects/change-events/guided/utils";
import { reviewImpactStep, reviewStep } from "src/routes/projects/change-events/guided/workflows/sharedSteps";
import { defineWorkflow } from "src/routes/projects/change-events/guided/workflows/types";
import { ApplyConfigurationFormInput, SelectConfigurationStep } from "../2.SelectConfigurationStep";

type FormInput = ApplyConfigurationFormInput;

const formConfig: ObjectConfig<FormInput> = {
  selectedConfigType: { type: "value" },
  selectedConfigId: { type: "value" },
};

export const applyFullConfigurationWorkflow = defineWorkflow<FormInput>({
  workflow: ChangeEventWorkflow.ApplyFullConfiguration,
  formConfig,
  steps: [
    {
      value: GuidedChangeEventStep.SelectConfiguration,
      label: "Select New Config",
      isComplete: (form) => !!form.selectedConfigId.value,
      render: (form) => <SelectConfigurationStep formState={form} />,
    },
    {
      value: GuidedChangeEventStep.ReviewConfiguration,
      label: "Review New Config",
      isComplete: () => false,
      disabled: (form) => !form.selectedConfigId.value,
      render: () => <div css={Css.sm.gray700.$}>This step is not part of the prototype yet.</div>,
    },
    reviewImpactStep(),
    reviewStep(),
  ],
  useActions: () => {
    return {
      // TODO: submit the change event for the apply-full-configuration flow.
      onSubmit: async () => {},
    };
  },
});
